import { apiUtils } from '../shared/utils';

const getTotal = (params = {}) =>
  apiUtils.post('calculateTotal', params);

const submitOrder = (params = {}) =>
  apiUtils.post('signup', params);

const submitEmail = (params = {}) =>
  apiUtils.post('email', params);

export { getTotal, submitOrder, submitEmail };
